import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {MatTableDataSource} from '@angular/material/table';
import {AppTranslateService} from '../../../modules/services/translate/app-translate.service';

@Component({
    selector: 'app-certificat-details',
    templateUrl: './certificat-details.component.html',
    styleUrls: ['./certificat-details.component.css']
})
export class CertificatDetailsComponent implements OnInit {
    certeficatesDetails = [];
    dataSource: MatTableDataSource<any>;

    displayedColumns = [];
    labels = [
        'Nom de l' + '\'' + 'utilisateur',
        'Nom de domaine',
        'Nom de l' + '\'' + 'émetteur',
        'Nom de domaine de l' + '\'' + 'émetteur',
        'Date d' + '\'' + 'émission',
        'Date d' + '\'' + 'expiration',
        'Valide Pour'
    ];

    dataColumns = [
        'commonName',
        'domainName',
        'issuerCommonName',
        'issuerDomainName',
        'notBefore',
        'notAfter',
        'keyUsages'
    ];

    constructor(@Inject(MAT_DIALOG_DATA) private data: any,
                public appTranslateService: AppTranslateService) {
        this.certeficatesDetails = data.certificatdetails;
    }

    ngOnInit(): void {

    }


}
